import pageDetailsReducer from './reducers';

export { default as pageDetailsActions } from './actions';
export { default as pageDetailsSelectors } from './selectors';

export default pageDetailsReducer;
